import React, { useState } from 'react';
import TimeSettingFormItem from 'components/FormFields/TimeSettingFormItem';
import { timeFormatValidation, getTimeList } from 'utils/time';
import dayjs from 'dayjs';
import clsx from 'clsx';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);

const EventTime = ({
  eventStart,
  setEventStart,
  eventEnd,
  setEventEnd,
  setTimeOnDate,
  showTz,
  timeFormat = '12',
}) => {
  const [timeInputsCounter, setTimeInputsCounter] = useState(0);
  const timeList = getTimeList(timeFormat);

  const startTime = dayjs(eventStart).format('HH:mm:ss');
  const endTime = dayjs(eventEnd).format('HH:mm:ss');

  // Need to make sure start time isn't later than end time so we want to handle
  // time updates for both start and end in one go, then update a separate state variable
  // that will fire the update function.
  const handleTimeChange = ({ start, end }) => {
    let _start = eventStart;
    let _end = eventEnd;

    if (start) {
      const time = timeFormatValidation(start);
      if (time) {
        _start = setTimeOnDate(_start, time);
        setEventStart(_start);
      } else {
        resetTimeInputs();
      }
      if (!_end || dayjs(_start).isSameOrAfter(dayjs(_end))) {
        _end = dayjs(_start).add(1, 'hour').format();
        setEventEnd(_end);
      }
      return;
    }
    if (end) {
      const time = timeFormatValidation(end);
      if (time) {
        _end = setTimeOnDate(_end, time);
        setEventEnd(_end);
      } else {
        resetTimeInputs();
      }
      if (!_start || dayjs(_start).isSameOrAfter(dayjs(_end))) {
        _start = dayjs(_end).subtract(1, 'hour').format();
        setEventStart(_start);
      }
    }
  };

  const resetTimeInputs = () => {
    setTimeInputsCounter(timeInputsCounter + 1);
  };

  return (
    <div className={clsx('event-card__time-picker', showTz && 'event-card__time-picker--constrained')}>
      <TimeSettingFormItem
        // Refresh widget when data changes.
        key={`start-time-${startTime}-${timeFormat}-${timeInputsCounter}`}
        name="Start time"
        setTime={(value) => handleTimeChange({ start: value })}
        time={startTime}
        timeFormat={timeFormat}
        timeList={timeList}
      />
      <TimeSettingFormItem
        // Refresh widget when data changes.
        key={`end-time-${endTime}-${timeFormat}-${timeInputsCounter}`}
        name="End time"
        setTime={(value) => handleTimeChange({ end: value })}
        time={endTime}
        timeFormat={timeFormat}
        timeList={timeList}
      />
    </div>
  );
};

export default EventTime;
